import { getInternationalPortfolio } from "../../actions/ApiCalls";
import { useEffect, useState } from "react";
import { IMAGE_URL } from "../../path";
import "./InternationalPortfolio.css"; // import the CSS

function InternationalPortfolio() {
    const [brands, setBrands] = useState<any[]>([]);

    useEffect(() => {
        getInternationalPortfolio()
            .then(response => setBrands(response.data.data))
            .catch(error => console.error("Failed to fetch brands:", error));
    }, []);

    return (
        <div className="grid-container">
            {brands.map((brand, index) => (
                <a href={`/our-wines/international/${brand.slug}`}>
                    <div key={index} className="grid-item">
                        <img
                            src={`${IMAGE_URL}${brand.bw_logo}`}
                            alt={brand.name}
                            className="brand-image"
                        />
                    </div>
                </a>
            ))}
        </div>
    );
}

export default InternationalPortfolio;
